import { defineComponent as v, useCssVars as g, unref as c, computed as b, openBlock as f, createElementBlock as h } from "vue";
var s = {};
Object.defineProperty(s, "__esModule", { value: !0 });
s.createAvatar = u = s.getGradientColors = void 0;
function i(r) {
  var a;
  const t = (a = r.match(/.{1,7}/g)) === null || a === void 0 ? void 0 : a.splice(0, 5), e = [];
  return t == null || t.forEach((d) => {
    let n = 0;
    for (let o = 0; o < d.length; o += 1)
      n = d.charCodeAt(o) + ((n << 5) - n), n = n & n;
    const l = [0, 0, 0];
    for (let o = 0; o < 3; o += 1) {
      const _ = n >> o * 8 & 255;
      l[o] = _;
    }
    e.push(`rgb(${l[0]}, ${l[1]}, ${l[2]})`);
  }), e;
}
var u = s.getGradientColors = i;
function p(r, a) {
  const t = i(a), e = typeof r == "string" ? document.querySelector(r) : r;
  if (!e)
    throw new Error("Avatar element not found");
  e.style.borderRadius = "50%", e.style.boxShadow = "inset 0 0 0 1px rgba(0, 0, 0, 0.1)", e.style.backgroundColor = t[0], e.style.backgroundImage = `
    radial-gradient(at 66% 77%, ${t[1]} 0px, transparent 50%),
    radial-gradient(at 29% 97%, ${t[2]} 0px, transparent 50%),
    radial-gradient(at 99% 86%, ${t[3]} 0px, transparent 50%),
    radial-gradient(at 29% 88%, ${t[4]} 0px, transparent 50%)
  `;
}
s.createAvatar = p;
s.default = p;
const x = { class: "web3-avatar" }, y = /* @__PURE__ */ v({
  __name: "Avatar",
  props: {
    address: {
      type: String,
      required: !0
    }
  },
  setup(r) {
    const a = r;
    g((e) => ({
      "6ebd55e8": c(t)[0],
      "6ebd5607": c(t)[1],
      "6ebd5626": c(t)[2],
      "6ebd5645": c(t)[3],
      "6ebd5664": c(t)[4]
    }));
    const t = b(() => u(a.address));
    return (e, d) => (f(), h("div", x));
  }
});
const A = (r, a) => {
  const t = r.__vccOpts || r;
  for (const [e, d] of a)
    t[e] = d;
  return t;
}, C = /* @__PURE__ */ A(y, [["__scopeId", "data-v-75502b3d"]]);
export {
  C as default
};
